module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.7-266.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.7.md
// module id = 708
// module chunks = 238